<template>
  <div id="app">
    <!-- <div
      class="switchLan"
      v-if="!['/register', '/registerH5'].includes($route.path)"
    >
      <div
        :class="['lng', lng === item && 'active']"
        @click="switchLanguage(item)"
        v-for="item in list"
        :key="item"
      >
        {{ item === "zh" ? "中" : "EN" }}
      </div>
    </div> -->
    <a-config-provider :locale="locale">
      <router-view></router-view>
    </a-config-provider>
  </div>
</template>

<script>
// import {Button} from 'ant-design-vue'
import api from "@/utils/api.js";
import zhCN from "ant-design-vue/lib/locale-provider/zh_CN";
export default {
  name: "App",
  components: {
    // 'a-button': Button,  // 使用 Ant Design Vue 按钮组件
  },
  data() {
    return {
      lng: this.$i18n.locale,
      list: ["zh", "en"],
      locale: zhCN,
    };
  },
  created() {
    this.addFooterCount();
  },
  methods: {
    //增加访问量
    async addFooterCount() {
      await api.addFooterCount(window.$configApi.webSiteId);
    },
    switchLanguage(lang) {
      this.lng = lang;
      this.$i18n.locale = lang; // 切换语言
    },
  },
  watch: {
    "$i18n.locale": {
      handler(val) {
        this.lng = val;
      },
    },
  },
};
</script>

<style lang="less" scoped></style>
